module.exports = __webpack_public_path__ + "static/media/loc1_img12.e7cc0c4f.jpg";